import isTemporaryIdReduxUtil from 'modules/redux/utils/is-temporary-id'
import getIdReduxUtil from 'modules/redux/utils/get-id'

function isNewReduxUtil (instance) {
  if (!instance) {
    return true
  }
  return isTemporaryIdReduxUtil(
    getIdReduxUtil(instance)
  )
}

export default isNewReduxUtil
